import { ErrorMessage, Field, Formik } from "formik";
import React, { useState } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { IProductCategory } from "../../customTypings/ProductCategory";
import { productCategoryService } from "../../services";
import { showToastSuccess, showToastError } from "../../helpers";
import { LoadingSpinner } from "../../components/LoadingSpinner";

type Props = {
    show: boolean;
    currentCategory?: IProductCategory;
    onClose: (updated: boolean) => void;
};

const ProductCategoryEditPage: React.FC<Props> = ({ show, currentCategory, onClose }) => {
    const [alertVariant, setAlertVariant] = useState("danger");

    const handleClose = () => onClose(false);

    return (
        <Modal centered show={show} keyboard={false} onHide={handleClose}>
            <Formik
                initialValues={{
                    name: currentCategory?.name
                }}
                enableReinitialize
                onSubmit={(values, { setStatus, setSubmitting, setFieldError }) => {
                    setStatus();
                    setSubmitting(false);
                    const updatedCategory: IProductCategory = {
                        id: currentCategory?.id,
                        name: values.name
                    };
                    productCategoryService.edit(updatedCategory).then(
                        (response) => {
                            setSubmitting(false);
                            if (response.status !== "Failure") {
                                showToastSuccess("Category updated successfully!");
                                setTimeout(() => onClose(true), 1000);
                            } else {
                                setAlertVariant("danger");
                                showToastError(response.message);
                            }
                        },
                        (error: any) => {
                            setAlertVariant("danger");
                            if (error.status === 400 && error.errors) {
                                Object.keys(error.errors).forEach((key) => {
                                    const messages = error.errors[key];
                                    if (Array.isArray(messages)) {
                                        messages.forEach((message) => showToastError(message));
                                    }
                                });
                            } else {
                                showToastError("An unexpected error occurred!");
                            }
                            setSubmitting(false);
                        }
                    );
                }}
            >
                {({ errors, status, touched, isSubmitting, handleSubmit, values, handleChange, setFieldValue }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Modal.Header closeButton>
                            <Modal.Title>Edit Product Category</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group as={Row} className="mb-3" controlId="name">
                                <Form.Label column md={3}>
                                    Product Category Name <span style={{ color: 'red' }}>*</span>
                                </Form.Label>
                                <Col md={9}>
                                    <Field name="name" type="text" className={"form-control" + (errors.name && touched.name ? " is-invalid" : "")} value={values.name} />
                                    <ErrorMessage name="name" component="div" className="invalid-feedback" />
                                </Col>
                            </Form.Group>

                            {status && (
                                <Alert variant={alertVariant} className="mt-3">
                                    {status}
                                </Alert>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="form-group">
                                <Button variant="primary" disabled={isSubmitting} type="submit" className="me-2">
                                    {isSubmitting ? <LoadingSpinner text="Editing Category..." /> : "Update Category"}
                                </Button>
                                <Button variant="secondary" onClick={handleClose}>
                                    Cancel
                                </Button>
                            </div>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export { ProductCategoryEditPage };
